import { ROUTE_API } from "constant";
import {
  IBaseDataForPaginate,
  IBaseDataOutputModel,
  IDetailChangeRevisionOutputModel,
  IGetDetailInventoryOutputModel,
  IGetInventoryOutputModel,
  TRevisionOutputModel,
} from "interfaces";
import { IGetInventoryInputModel } from "interfaces/inventory/api";
// import { ICreatePostInputMode } from "interfaces";
import apiV3 from "utils/api.v3";

export const InventoryServices = {
  createInventory,
  updateInventory,
  getInventoriesPaginate,
  getDetailInventory,

  /** Inventory Revision */
  getListInventoryRevision,
  getDiffInventoryPost,
};

function createInventory(data: FormData) {
  return apiV3.post<any>(
    { url: ROUTE_API.INVENTORY_ROUTER.CREATE_INVENTORY, data },
    { "Content-Type": "multipart/form-data" }
  );
}

function updateInventory(data: FormData, inventoryId: string) {
  return apiV3.put<any>(
    { url: ROUTE_API.INVENTORY_ROUTER.UPDATE_INVENTORY.replace("{INVENTORY_ID}", inventoryId), data },
    { "Content-Type": "multipart/form-data" }
  );
}

function getInventoriesPaginate(data: IGetInventoryInputModel) {
  return apiV3.post<IBaseDataForPaginate<IGetInventoryOutputModel>>({
    url: ROUTE_API.INVENTORY_ROUTER.GET_INVENTORIES,
    data,
  });
}

function getDetailInventory(inventoryId: string) {
  return apiV3.get<IBaseDataOutputModel<IGetDetailInventoryOutputModel>>({
    url: ROUTE_API.INVENTORY_ROUTER.GET_DETAIL_INVENTORY.replace("{INVENTORY_ID}", inventoryId),
  });
}

function getListInventoryRevision(inventoryId: string) {
  return apiV3.get<IBaseDataOutputModel<TRevisionOutputModel<IGetDetailInventoryOutputModel>[]>>({
    url: ROUTE_API.INVENTORY_ROUTER.GET_LIST_INVENTORY_REVISION.replace("{INVENTORY_ID}", inventoryId),
  });
}

function getDiffInventoryPost(revisionId: string) {
  return apiV3.get<IBaseDataOutputModel<IDetailChangeRevisionOutputModel[]>>({
    url: ROUTE_API.INVENTORY_ROUTER.GET_DIFF_INVENTORY_REVISION.replace("{REVISION_ID}", revisionId),
  });
}

// function getCountService(data: { categoryId: string }) {
//   return apiV3.get<IGetTotalOutputModel>({ url: ROUTE_API.SERVICE_ROUTE.COUNT_TOTAL_SERVICE, query: data });
// }

// function getDetailService(input: { id: string }) {
//   return apiV3.get<any>({
//     url: ROUTE_API.SERVICE_ROUTE.GET_SERVICE_DETAIL.replace("{SERVICE_ID}", input.id),
//   });
// }

// function getCateService(input: { search?: string }) {
//   return apiV3.get<IGetCateServiceOutputModel[]>({
//     url: ROUTE_API.SERVICE_ROUTE.LIST_CATE_SERVICE,
//     query: input,
//   });
// }

// function updateCateService(data: FormData, cateServiceId: string) {
//   return apiV3.post<any>(
//     { url: ROUTE_API.SERVICE_ROUTE.UPDATE_CATE_SERVICE.replace("{CATE_SERVICE_ID}", cateServiceId), data },
//     { "Content-Type": "multipart/form-data" }
//   );
// }
